module.exports = __webpack_public_path__ + "static/driftglobe-b989d8ba6eeb7c3b8555f6e597ee6d33.jpeg";